import React from "react";
import Box from "@mui/material/Box";
import { Tooltip } from "@mui/material";

const CustomTooltip = (title,image) => 
    {
        return (
            <Tooltip title={title}>
                <Box component="img"  sx={{height: 24,width: 24}} src={image}/>
                </Tooltip>
        )
    };

export default CustomTooltip;
